export default __webpack_public_path__ + "static/media/7-cn.a267d6cb.webp";